import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitch } from './LanguageSwitch';
import logo from '../assets/logo1-removebg-preview.png';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export function Navigation() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigation = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(path);
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-50 text-gray-600 py-6">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div 
            onClick={handleNavigation('/')}
            className="cursor-pointer"
          >
            <img 
              className='w-20 h-15' 
              src={logo} 
              alt="Logo" 
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')} 
              className="hover:text-teal-600 transition-colors"
            >
              {t.nav.features}
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="hover:text-teal-600 transition-colors"
            >
              {t.nav.pricing}
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="hover:text-teal-600 transition-colors"
            >
              {t.nav.testimonials}
            </button>
            <LanguageSwitch />
            <button 
              onClick={handleNavigation('/login')}
              className="inline-block border-2 border-[#0D3C4C] text-[#0D3C4C] px-6 py-2.5 rounded-xl font-semibold hover:bg-[#0D3C4C]/10 transition-colors"
            >
              {t.nav.login}
            </button>
            <button 
              onClick={handleNavigation('/register')}
              className="inline-block bg-[#0D3C4C] text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-[#0D3C4C]/90 transition-colors"
            >
              {t.nav.startTrial}
            </button>
          </div>
          <div className="md:hidden flex items-center gap-2">
            {/* Le sélecteur de langue est maintenant visible directement dans la barre de navigation */}
            <div className="mr-1">
              <LanguageSwitch />
            </div>
            <button 
              className="text-[#0D3C4C]"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Menu mobile */}
        <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
          <div className="flex flex-col items-center space-y-4 pt-4 pb-6 border-t mt-4">
            <button 
              className="w-full text-center py-2 hover:text-teal-600 transition-colors"
              onClick={() => scrollToSection('features')}
            >
              {t.nav.features}
            </button>
            <button 
              className="w-full text-center py-2 hover:text-teal-600 transition-colors"
              onClick={() => scrollToSection('pricing')}
            >
              {t.nav.pricing}
            </button>
            <button 
              className="w-full text-center py-2 hover:text-teal-600 transition-colors"
              onClick={() => scrollToSection('testimonials')}
            >
              {t.nav.testimonials}
            </button>
            <button 
              onClick={handleNavigation('/login')}
              className="w-full border-2 border-[#0D3C4C] text-[#0D3C4C] px-6 py-2.5 rounded-xl font-semibold hover:bg-[#0D3C4C]/10 transition-colors"
            >
              {t.nav.login}
            </button>
            <button 
              onClick={handleNavigation('/register')}
              className="w-full bg-[#0D3C4C] text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-[#0D3C4C]/90 transition-colors"
            >
              {t.nav.startTrial}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}